export default __webpack_public_path__ + "static/media/mainlogo.2898f51d.png";